import type { DataNode } from 'antd/es/tree';
import { NodeCard } from 'components/HierarchicalTrees/TreeNodeCard';

export const buildEntityToTPPTree = (data: any[]): DataNode[] => {
  const map = new Map<string, any>();
  const roots = new Map<string, any>();

  const fallback = '—';

  const safeVal = (v: any) =>
    v === null || v === undefined || v === '' ? fallback : String(v);

  const safeKey = (v: any, prefix: string) =>
    `${prefix}-${v === null || v === undefined || v === '' ? 'empty' : v}`;

  const getOrCreate = (
    key: string,
    label: string,
    value: string,
    parent?: any,
    info?: any,
  ) => {
    if (!map.has(key)) {
      const node = {
        key,
        title: <NodeCard label={label} value={value} info={info} />,
        children: [],
      };

      map.set(key, node);
      if (parent) parent.children.push(node);
    }

    return map.get(key);
  };

  data.forEach((item) => {
    const entity = getOrCreate(
      `entity-${item.entity_id}`,
      'Entity',
      safeVal(item.name_of_entity),
    );

    roots.set(entity.key, entity);

    const tpp = getOrCreate(
      `${entity.key}-${safeKey(item.third_party_id, 'tpp')}`,
      'Third Party Service Provider',
      safeVal(item.third_party_name),
      entity,
    );

    const contract = getOrCreate(
      `${tpp.key}-${safeKey(item.contract_id, 'contract')}`,
      'Contract',
      safeVal(item.contract_name),
      tpp,
    );

    const service = getOrCreate(
      `${contract.key}-${safeKey(item.ict_service_id, 'service')}`,
      'ICT Service',
      safeVal(item.ict_service_name),
      contract,
    );

    getOrCreate(
      `${service.key}-${safeKey(item.ict_system_id, 'system')}`,
      'ICT System',
      safeVal(item.ict_system_name),
      service,
    );
  });

  return Array.from(roots.values());
};
